import React, { Suspense, memo } from 'react';

// Lazy-load the chart.js-backed implementation; see BarChart/index.js for rationale.
const DoughnutChartInner = React.lazy(() => import('./DoughnutChartInner'));

const DoughnutChart = (props) => (
  <Suspense fallback={null}>
    <DoughnutChartInner {...props} />
  </Suspense>
);

export default memo(DoughnutChart);
